/**
 * возможность легко применять один из class к body
 */
import {Widget} from "base/assets/js/widget/Widget.js";
import {Comm} from "base/assets/js/widget/Comm.js";
import {CWays} from "base/assets/js/widget/CWays.js";

export class Comms extends Widget {

	_aGuideWidths = [];
	iTopicId = null;
	bGuest = true;
	/**
	 * @type {number} максимальная вложенность комментариев
	 */
	_iMaxLev = 1;

	/**
	 * @type {Comm[]} массив ссылок на виджеты комментариев
	 */
	_aItems = [];

	run() {

		this._my( { "topic-id": 'i:iTopicId', guest: "b:bGuest" } );

		// кнопки скрыть показать панельку навигации по комментам
		this._on( 'ShowNavs?', 'click', ( oEvent ) => {
			this._mod( '', 'comms_navs', true );
		} );

		this._on( 'HideNavs?', 'click', ( oEvent ) => {
			this._mod( '', 'comms_navs', false );
		} );

		// по мере добавления комментариев в этот контейнер, регистрируем ссылку на него,
		// в массиве this._aItems комментарии в том порядке как на странице
		this._aItems = this._rel()
			.child()
			.canEmpty()
			.typeOf( Comm )
			.onAdd( ( oComm ) => {
				oComm.setComms( this );

				// вставляем элемент в массив, согласно его индексу в DOM
				let bInsert = false;
				const oCommPrev = this._rel( oComm.bl() ).prev().typeOf( Comm ).canEmpty().find();
				if( oCommPrev ) {
					let iCommPrevIndex = this._aItems.indexOf( oCommPrev );
					if( iCommPrevIndex !== -1 ) {
						this._aItems.splice( iCommPrevIndex + 1, 0, oComm );
						bInsert = true;
					}
				}
				if( !bInsert ) {
					const oCommNext = this._rel( oComm.bl() ).next().typeOf( Comm ).canEmpty().find();
					if( oCommNext ) {
						let iCommNextIndex = this._aItems.indexOf( oCommNext );
						if (iCommNextIndex !== -1) {
							this._aItems.splice(iCommNextIndex - 1, 0, oComm);
							bInsert = true;
						}
					}
				}
				if( !bInsert ) {
					this._aItems.push( oComm );
				}

			} )
			.onDrop( ( oComm ) => {
				let iIndex = this._aItems.indexOf( oComm );
				if( iIndex !== -1 ) {
					this._aItems.splice( iIndex, 1 );
				}
			} )
			.find( true );

		this._aItems.forEach( ( oComm ) => {
			oComm.setComms( this );
		} );
	}

	resetActive() {
		// убираем помеченные комментарии
		this.bl().querySelectorAll( '.comm_active' ).forEach( ( eElement ) => {
			this._mod( eElement, 'comm_active', false );
		} );
	}

	setMaxLev( iLev ) {
		if( iLev > this._iMaxLev ) {
			this._iMaxLev = iLev;
		}
	}

	resetEmpty() {
		this._mod( '', 'comms_empty', false );
	}

	loadByMp( sMp ) {
		// отдельная история когда комментарий новый
		// if( sMp === '1' ) {
		// 	return this._loadBodies( sMp, sMp, sMp )
		// 		.then( ( { sHtml } ) => {
		// 			return this._html( 'Items', sHtml );
		// 		} );
		// }
		// const oCommPrev = this._findPrevByMp( sMp );
		// return this.loadByCommFrom( oCommPrev, sMp );
		const oRequest = {
			cnav: "one",
			cnavfrom: sMp
		};
		return this.loadByRange( sMp, sMp, oRequest );
	}

	loadByRange( sMpFrom, sMpTo, oRequest ) {
		let [ oPrev, oNext ] = this.findPrevNextByRange( sMpFrom, sMpTo );
		return this._loadBodies( oPrev ? oPrev.getMp() : null, oNext ? oNext.getMp() : null, oRequest )
			.then( ( { sHtml } ) => {

				let eFrom;
				let sInsertPosition;

				if( oPrev ) {
					// есть предыдущий элемент

					// поудаляем старое
					let eElement = oPrev.bl();
					while( ( eElement = eElement.nextElementSibling ) ) {
						if( oNext && oNext.bl() === eElement ) {
							break;
						}
						eElement.parentNode.removeChild( eElement );
					}

					eFrom = oPrev.bl();
					sInsertPosition = 'afterend';

				} else if( oNext ) {
					// есть следующий элемент

					// поудаляем старое
					let eElement = oNext.bl();
					while( ( eElement = eElement.previousElementSibling ) ) {
						if( oPrev && oPrev.bl() === eElement ) {
							break;
						}
						eElement.parentNode.removeChild( eElement );
					}

					eFrom = oNext.bl();
					sInsertPosition = 'beforebegin';

				} else {

					// ничего нету
					eFrom = this._el( 'Items' );
					sInsertPosition = null;
				}

				return this._html( eFrom, sHtml, sInsertPosition )
					.then( () => {
						const oCWays = this._rel().typeOf( CWays ).find();
						oCWays.setMaxLevel( this._iMaxLev );
						// или по предыдущему комменту обновим, или по первому элементу
						oCWays.refresh( [ oPrev ? oPrev : this._aItems[ 0 ] ] );
					} );
			} );
	}

	findPrevNextByRange( sMpFrom, sMpTo ) {

		let oPrev = null;
		let oNext = null;

		if( !this._aItems.length ) {
			return [ oPrev, oNext ];
		}

		//const oCommFrom = this._rel().child().typeOf( Comm ).index( sMpFrom ).canEmpty().find();
		//if( oCommFrom ) {
		//	let iFromIndex = this._aItems.indexOf( oCommFrom );
		//	if( iFromIndex > 0 ) {
		//		oPrev = this._aItems[ iFromIndex - 1 ];
		//	}
		//}

		// найдем предыдущий комментарий
		if( sMpFrom !== '' ) {
			let aMpFrom = Comm.mp2a( sMpFrom );
			for (let iIndex = 0; iIndex < this._aItems.length; iIndex++) {
				let oComm = this._aItems[iIndex];
				let aMp = Comm.mp2a(oComm.getMp());
				if (this._mpCmp(aMp, aMpFrom) === 1) {
					break;
				}
				oPrev = oComm;
			}
		}

		// найдем следующий
		if( sMpTo !== '' ) {
			let aMpTo = Comm.mp2a(sMpTo);
			if (oPrev) {
				let iPrevIndex = this._aItems.indexOf(oPrev);
				if (iPrevIndex === -1) {
					throw new Error('bad find prev comm');
				}
				for (let iIndex = iPrevIndex; iIndex < this._aItems.length; iIndex++) {
					let oComm = this._aItems[iIndex];
					let aMp = Comm.mp2a(oComm.getMp());
					if (this._mpCmp(aMp, aMpTo) !== -1) {
						oNext = oComm;
						break;
					}
				}
			} else {
				for (let iIndex = this._aItems.length - 1; iIndex >= 0; iIndex--) {
					let oComm = this._aItems[iIndex];
					let aMp = Comm.mp2a(oComm.getMp());
					if (this._mpCmp(aMp, aMpTo) === -1) {
						break;
					}
					oNext = oComm;
				}
			}
		}
		return [ oPrev, oNext ];
	}

	getItems() {
		return this._aItems;
	}

	_findPrevByMp( sMp ) {
		let aMpOrigin = Comm.mp2a( sMp );
		let aMp = Comm.mp2a( sMp );
		let oCommPrev = null;

		// сначала найдем верхнего уровня Comm
		while( !( oCommPrev = this._rel().typeOf( Comm ).index( aMp.join( '.' ) ).canEmpty().find() ) ) {
			aMp = this._mpPrev( aMp );
		}

		if( oCommPrev ) {

			// потом спустимся по веткам, если они тоже подходят
			let eElement = oCommPrev.bl();
			let oComm;
			while ( ( eElement = eElement.nextElementSibling ) ) {
				oComm = this._rel().typeOf( Comm ).child().from( eElement ).canEmpty().find();
				if( !oComm ) {
					continue;
				}
				let aMpNext = Comm.mp2a( oComm.getMp() );
				if( this._mpCmp( aMpNext, aMpOrigin ) >= 0 ) {
					break;
				}

				// перемещаемся глубже
				oCommPrev = oComm;
			}
		}
		return oCommPrev;
	}

	showComment( sMp ) {
		// если подгружен коммент, скроллим к нему
		if( this._scrollTo( sMp ) ) {
			return Promise.resolve();
		}
		// или подгружаем, а потом скроллим
		return this.loadByMp( sMp ).then( () => {
			this._scrollTo( sMp );
		} );
	}

	_scrollTo( sMp ) {
		const oComm = this._rel().index( sMp ).typeOf( Comm ).canEmpty().find();
		if( !oComm ) {
			return false;
		}

		this.resetActive();
		const yOffset = -60;
		const y = oComm.bl().getBoundingClientRect().top + window.pageYOffset + yOffset;

		// const oCWays = this._getCWays();

		// try {
		// 	oCWays.skipScroll( true );
		//
		// 	const fnCheckScrollEnd = () => {
		// 		const oRect = oComm.bl().getBoundingClientRect();
		//
		// 		if( oRect.top >= 0 && oRect.bottom <= (window.innerHeight || document.documentElement.clientHeight) ) {
		// 			oCWays.refresh( [oComm] ).then( () => {
		// 				oCWays.skipScroll( false );
		// 			} );
		// 		} else {
		// 			console.log( 'request' );
		// 			requestAnimationFrame( fnCheckScrollEnd );
		// 		}
		// 	}
		//
		// 	requestAnimationFrame( fnCheckScrollEnd );
		// } catch( e ) {}

		window.scrollTo({ top: y, behavior: 'smooth' } );
		//window.scrollTo({ top: y } );
		oComm.active( true );
		return true;
	}

	_findPrevByEl( eElement ) {
		let oCommPrev;
		while( ( eElement = eElement.previousElementSibling ) ) {
			oCommPrev = this._rel().typeOf( Comm ).child().from( eElement ).canEmpty().find();
			if( oCommPrev ) {
				break;
			}
		}
		return oCommPrev;
	}

	_loadBodies( sMpFrom = null, sMpTo = null, oRequest = null ) {

		// убираем помеченные комментарии
		this.resetActive();

		const oFormData = new FormData();
		oFormData.append( 'iTopicId', this.iTopicId );
		if( sMpFrom ) {
			oFormData.append('sMpFrom', sMpFrom);
		}
		if( sMpTo ) {
			oFormData.append('sMpTo', sMpTo);
		}
		if( oRequest ) {
			for( let sKey in oRequest ) {
				oFormData.append( sKey, oRequest[ sKey ] );
			}
		}

		return this.post( '/search/comments', oFormData )
			.catch( ::this.ajaxPopupCatch );
	}

	/**
	 * найти MP, меньший, чем передан
	 * @param {int[]} aMp
	 */
	_mpPrev( aMp ) {
		if( aMp[ aMp.length - 1 ] >= 1 ) {
			aMp[ aMp.length - 1 ] = aMp[ aMp.length - 1 ] - 1;
			return aMp;
		} else {
			return aMp.slice( 0, aMp.length - 1 );
		}
	}

	/**
	 * сравнить два MP
	 * @param {int[]} aMp
	 */
	_mpCmp( aA, aB ) {
		const iLen = Math.max( aA.length, aB.length );
		for( let i = 0; i < iLen; i++ ) {
			if( ( aA[ i ] || 0 ) > ( aB[ i ] || 0 ) ) {
				return 1;
			} else if( ( aA[ i ] || 0 ) < aB[ i ] || 0 ) {
				return -1;
			}
		}
		return 0;
	}
}
